import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon, BookOpenIcon, CalendarIcon, BadgeCheck, CheckCircle } from 'lucide-react';
const HeaderGlpAdv1 = () => {
  return <header className="bg-white" style={{
    fontFamily: 'Georgia, Cambria, "Times New Roman", serif'
  }} data-id="element-17476" data-mp="1tdrwp2rtruvp">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-17477" data-mp="22g12xgg2923a"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-17478" data-mp="2h5gv90v8pfl3">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-17479" data-mp="2h7jqbzb91ywo">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-17480" data-mp="2c5kmypfif1zq">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-17481" data-mp="2q3sqxhayr3ke">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-17482" data-mp="vse0eya4p03l">
          <div className="text-left" data-id="element-17483" data-mp="2mtb22551836b">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-17484" data-mp="2muvwzvv9do4p">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-17485" data-mp="36jd2u00r13gg">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>

      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-17486" data-mp="3fj09b08c4zgd">
        <div className="max-w-4xl mx-auto" data-id="element-17487" data-mp="3kgtafeus739s">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-17488" data-mp="3kgjkfr9qkw43">
            INVESTIGATIVE REPORT
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-6" data-id="element-17489" data-mp="1q28wdl0yu5zd">
            How To Take Any GLP-1 Drug Without The Nightmares, Anxiety, Or
            Emotional Numbness That Makes You Wonder If It's Worth It
          </h1>

          <div className="my-6" data-id="element-17490" data-mp="1e33unn3c4xxg">
            <img src="https://cdn.magicpatterns.com/uploads/1rggcG23avR6QSjaCBdvck/Untitled_(1500_x_1000_px)_(1200_x_1000_px)_(1600_x_1200_px)_(3).png" alt="Before and after transformation" className="w-full rounded-lg shadow-md" data-id="element-17491" data-mp="1s0seqspkw11g" />
          </div>

          <p className="text-lg font-medium text-gray-700 mb-6 leading-relaxed border-l-4 border-gray-800 pl-4" data-id="element-17492" data-mp="20z428lv5eipo">
            A nurse practitioner's discovery—backed by research from Uppsala
            University that saved my sister and is now helping over 36,700
            people lose weight without losing themselves.
          </p>

          {/* Author Byline */}
          <div className="flex items-center gap-3 mb-6 pb-5 border-b border-gray-200" data-id="element-17493" data-mp="2kpzc3odaqkl4">
            <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 bg-gray-200" data-id="element-17494" data-mp="2fr5y7uu3krkf">
              <img src="https://cdn.magicpatterns.com/uploads/4PvNLd6RsPB1kVDZBzePem/c844778a-6484-4fd0-ade7-865535abf330.png" alt="Journalist" className="w-full h-full object-cover" data-id="element-17495" data-mp="2zbmvh7bodl2x" />
            </div>
            <div className="flex-1" data-id="element-17496" data-mp="2pcnnlqyqhtgz">
              <div className="flex items-center gap-1 mb-1" data-id="element-17497" data-mp="2pftd37b9yxd8">
                <span className="text-sm font-medium text-gray-900" data-id="element-17498" data-mp="2ubqu7fud47r2">
                  Written by Sarah Mitchell
                </span>
                <BadgeCheck className="h-4 w-4 text-blue-600" data-id="element-17499" data-mp="2flt06j9r4nty" />
              </div>
              <div className="text-xs text-gray-600 mb-1" data-id="element-17500" data-mp="2kg6yatfst92b">
                Investigative Health Journalist • 17 Yrs Exp
              </div>
              <div className="flex items-center gap-3 text-xs text-gray-500" data-id="element-17501" data-mp="2bmbuppubrqos">
                <div className="flex items-center gap-1" data-id="element-17502" data-mp="2bk7t5ejwf3ro">
                  <ClockIcon className="h-3 w-3" data-id="element-17503" data-mp="1wq2ykx5qdtgl" />
                  <span data-id="element-17504" data-mp="1wre1yvv9kz76">14 min read</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-17505" data-mp="21nmlsmkepgko">
                  <EyeIcon className="h-3 w-3" data-id="element-17506" data-mp="34zjw6xu1v958" />
                  <span data-id="element-17507" data-mp="34y8tl1ccc7fp">31,542 views</span>
                </div>
              </div>
            </div>
          </div>

          <p className="mb-5 text-base leading-relaxed text-gray-700" data-id="element-17508" data-mp="3021u9reg9u6q">
            If you're on Semaglutide or Tirzepatide—and you're noticing things
            like:
          </p>

          <div className="space-y-2 mb-6" data-id="element-17509" data-mp="2q9vv9xps6ci1">
            <div className="flex items-start gap-2" data-id="element-17510" data-mp="2lat33duwg0rh">
              <CheckCircle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-17511" data-mp="2lcduiulx33l4" />
              <p className="text-gray-700 text-base leading-relaxed" data-id="element-17512" data-mp="2h8obeko0he7h">
                Anxiety that comes from nowhere and won't leave
              </p>
            </div>
            <div className="flex items-start gap-2" data-id="element-17513" data-mp="27bt9drsj4vog">
              <CheckCircle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-17514" data-mp="27de71qa54uqj" />
              <p className="text-gray-700 text-base leading-relaxed" data-id="element-17515" data-mp="aihrtzv0t99o">
                A flat, numb feeling where emotions used to be
              </p>
            </div>
            <div className="flex items-start gap-2" data-id="element-17516" data-mp="d47lspv3ep57">
              <CheckCircle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-17517" data-mp="d1d06v0ceya7" />
              <p className="text-gray-700 text-base leading-relaxed" data-id="element-17518" data-mp="i0pprnilmjgh">
                Vivid nightmares that jolt you awake
              </p>
            </div>
            <div className="flex items-start gap-2" data-id="element-17519" data-mp="rslmov8y83j4">
              <CheckCircle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-17520" data-mp="ruetcajkanr4" />
              <p className="text-gray-700 text-base leading-relaxed" data-id="element-17521" data-mp="3qbskaquiky0s">
                A sense of dread you can't explain
              </p>
            </div>
            <div className="flex items-start gap-2" data-id="element-17522" data-mp="42821psp16yk">
              <CheckCircle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-17523" data-mp="44ubjuz59wjf" />
              <p className="text-gray-700 text-base leading-relaxed" data-id="element-17524" data-mp="93fc5vib6i8e">
                Zero motivation to do things you used to love
              </p>
            </div>
            <div className="flex items-start gap-2" data-id="element-17525" data-mp="1kg816yjpsskr">
              <CheckCircle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-17526" data-mp="1kiu94zaipa3i" />
              <p className="text-gray-700 text-base leading-relaxed" data-id="element-17527" data-mp="3gib5vcgg4xx8">
                Feeling disconnected from people close to you
              </p>
            </div>
          </div>

          <p className="mb-5 text-base leading-relaxed text-gray-700" data-id="element-17528" data-mp="3pjiz3g43v8kg">
            ...you're not imagining it. You're not alone.
          </p>

          <p className="mb-5 text-base leading-relaxed text-gray-700" data-id="element-17529" data-mp="2xto16v26mak6">
            And it's not permanent—if you understand{' '}
            <strong data-id="element-17530" data-mp="2svcsinnmi63j">
              what's actually happening inside your body right now
            </strong>
            .
          </p>

          <p className="mb-6 text-base leading-relaxed text-gray-700" data-id="element-17531" data-mp="36n9esb2m1ls0">
            In my 17 years as an investigative health journalist, I've covered
            dozens of pharmaceutical controversies. But this one hit close to
            home.
          </p>
        </div>
      </div>
    </header>;
};
export default HeaderGlpAdv1;